import {
  SET_USER,
  SET_LOADER,
  SET_USER_CPF,
  SET_ERROR
} from '../actions/session';

export const initialState = {
  user: null,
  userCpf: '',
  isLoading: true,
  error: null
};

export default (state = initialState, payload) => {
  switch (payload.type) {
    case SET_USER:
      return {
        ...state,
        user: payload.user
      };
    case SET_LOADER:
      return {
        ...state,
        isLoading: payload.isLoading
      };
    case SET_USER_CPF:
      return {
        ...state,
        userCpf: payload.cpf
      };
    case SET_ERROR:
      return {
        ...state,
        error: payload.error
      };
    default:
      return state;
  }
};
